
import Header from './Header.vue'
import { computed, defineComponent, onMounted, ref } from 'vue'
import { ScreenInfo } from '@/types'
import ContactMap from '@/components/ContactMap.vue'
import Footer from '@/views/Footer.vue'
import { useMeta } from 'vue-meta'
import { metaData } from '@/dataset/index'

export default defineComponent({
  name: 'Contact',
  components: {
    Header,
    ContactMap,
    Footer,
  },

  setup () {
    useMeta({
      ...metaData[2],
    })

    const screenWidth = ref(innerWidth)

    const screenInfo = computed(
      (): ScreenInfo => ({
        isPlatform: screenWidth.value >= 530 ? 'desktop' : 'mobile',
      }),
    )

    const onScreenChange = () => {
      screenWidth.value = innerWidth
    }

    const onClickMain = () => {
      //
    }
   
    onMounted(() => {
      window.addEventListener('resize', onScreenChange)
    })

    return {
      screenInfo,
      onClickMain,
    }
  },
})
